/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { teeth } from './teethArray'

export default function SVGMouth({ selectedTeeth, onToothclick, selectedType, groupedTeethInfo }) {
  const [tooltip, setTooltip] = useState({ show: false, content: '', x: 0, y: 0 })
  const usedTeeth = teeth.filter((tooth) => {
    if (selectedType === 'all') return true
    if (selectedType === 'adult') return !tooth.child
    if (selectedType === 'child') return tooth.child
    return true
  })

  // Helper function to get service information for a specific tooth
  const getServiceInfoForTooth = (toothNumber) => {
    if (!groupedTeethInfo || !groupedTeethInfo.appointments) return null
    
    const services = []
    groupedTeethInfo.appointments.forEach(appointment => {
      if (appointment.teeth_list && appointment.teeth_list.includes(toothNumber)) {
        const serviceName = appointment.name || appointment.operation_name || 'Unknown Service'
        const serviceTime = appointment.fromStr || ''
        services.push({ name: serviceName, time: serviceTime })
      }
    })
    
    return services.length > 0 ? services : null
  }

  // Handle mouse enter for tooltip
  const handleMouseEnter = (event, toothNumber) => {
    if (!groupedTeethInfo || !selectedTeeth?.includes(toothNumber)) return
    
    const services = getServiceInfoForTooth(toothNumber)
    if (!services) return
    
    const rect = event.currentTarget.getBoundingClientRect()
    const content = services.map(service => 
      `${service.name}${service.time ? ` (${service.time})` : ''}`
    ).join('\n')
    
    setTooltip({
      show: true,
      content,
      x: rect.left + rect.width / 2,
      y: rect.top - 10
    })
  }

  // Handle mouse leave to hide tooltip
  const handleMouseLeave = () => {
    setTooltip({ show: false, content: '', x: 0, y: 0 })
  }

  // Handle mouse move to update tooltip position
  const handleMouseMove = (event) => {
    if (tooltip.show) {
      setTooltip(prev => ({
        ...prev,
        x: event.clientX + 10,
        y: event.clientY - 10
      }))
    }
  }

  // Add global mouse move listener when tooltip is shown
  useEffect(() => {
    if (tooltip.show) {
      document.addEventListener('mousemove', handleMouseMove)
      return () => document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [tooltip.show])

  return (
    <>
      <svg
        id='svglol'
        className={styles.mouth_svg}
        width='315'
        height='426'
        viewBox='0 0 315 426'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        {usedTeeth.map((tooth) => {
          const { id, d, stroke, strokeLinecap, strokeLinejoin, number, textpath } = tooth
          const isSelected = selectedTeeth?.includes(number)
          const hasServiceInfo = groupedTeethInfo && isSelected
          
          return (
            <g 
              key={id} 
              id={id + '-group'} 
              className={styles.tooth_group} 
              onClick={() => onToothclick(number)}
              onMouseEnter={hasServiceInfo ? (e) => handleMouseEnter(e, number) : undefined}
              onMouseLeave={hasServiceInfo ? handleMouseLeave : undefined}
              style={hasServiceInfo ? { cursor: 'help' } : {}}
            >
              <path
                id={id}
                d={d}
                stroke={stroke}
                strokeLinecap={strokeLinecap}
                strokeLinejoin={strokeLinejoin}
                className={styles.regular_tooth}
                strokeWidth='1.5'
                fill={isSelected ? 'var(--main-button-color)' : 'white'}
              />
              <path
                id={id + '-text'}
                d={textpath}
                className={styles.tooth_text}
                fill={isSelected ? 'var(--main-button-color)' : 'black'}
              />
            </g>
          )
        })}
      </svg>
      
      {/* Tooltip */}
      {tooltip.show && (
        <div 
          className={styles.tooltip}
          style={{
            position: 'fixed',
            left: tooltip.x,
            top: tooltip.y,
            transform: 'translate(-50%, -100%)',
            zIndex: 1000,
            pointerEvents: 'none'
          }}
        >
          {tooltip.content.split('\n').map((line, index) => (
            <div key={index} className={styles.tooltip_line}>
              {line}
            </div>
          ))}
        </div>
      )}
    </>
  )
}
